export default function ({ store, redirect }) {
  // If the user is not authenticated
  if (store.state.opportunity.opportunity.id === 0) {
    return redirect('/oportunidades')
  }
}
